import { render, staticRenderFns } from "./SBNextBack.html?vue&type=template&id=28e4432a&scoped=true&"
import script from "./SBNextBack.ts?vue&type=script&lang=ts&"
export * from "./SBNextBack.ts?vue&type=script&lang=ts&"
import style0 from "./SBNextBack.css?vue&type=style&index=0&id=28e4432a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e4432a",
  null
  
)

export default component.exports